<template>
  <div class="challenge_header_wrapper">
    <div class="challenge_header">
      <div class="inner">
        <!-- <button class="return sp" @click="this.$router.go(-1)">←</button> -->
        <h2 class="header_title">{{ cdata.data.name }}</h2>
        <!-- <button class="header_btn_edit" @click="rebase()">編集</button> -->
        <!-- <button class="header_btn_chip"><img src="./images/item_chip.svg" alt=""></button> -->
      </div>
    </div>
    <div class="challenge_detail">
      <div class="detail_header">
        <button class="header_status_user">
          <p class="user_icon"><img :src="chost.icon" /></p>
          <p class="user_name">{{ chost.name }}</p>
          <p class="user_status" v-bind:class="{ active: chost.challenge }">
            ◎チャレンジ中
          </p>
        </button>
        <div class="header_counter">
          <div>
            <p class="title">応援ポイント</p>
            <p class="counter">{{ cdata.mai_support }}mai</p>
          </div>
          <button
            class="header_btn_cheer"
            @click="maiSend(uid, uname, cdata.host, chost.name, cid)"
            :disabled="sendMai"
          >
            <p>応援</p>
            <i class="fas fa-rocket"></i>
          </button>
        </div>
      </div>
      <div class="detail_graph">
        <div class="graph_header">
          <p>開始日: {{ timeTransfer(cdata.created.seconds * 1000) }}</p>
          <p v-if="cdata.data.span_tab == 'per'">
            {{ "目標ペース" }}<span>{{ graph_mai(cdata.data) }}</span
            >枚/<span>{{ graph_day(cdata.data) }}</span
            >日
          </p>
          <p>
            {{
              cdata.data.span_tab == "span"
                ? timeTransfer(cdata.data.span.span)
                : ""
            }}
          </p>
        </div>
        <div class="graph">
          <div
            class="graph_color"
            :style="`width: ${
              4 +
              Number(graph_percent(cdata)) -
              (4 / 100) * Number(graph_percent(cdata))
            }%`"
          ></div>
          <p class="graph_percentage">{{ graph_percent(cdata) }}%</p>
        </div>
        <div class="graph_footer">
          <p>
            目標枚数: <span>{{ cdata.data.goal }}枚</span>
          </p>
          <p>最終更新日: <span>3日前</span></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebaseUtil from "@/firebase";

export default {
  props: ["uid", "uname", "cdata", "chost", "cid"],
  data() {
    return {
      sendMai: false,
    };
  },
  methods: {
    graph_percent(data) {
      return data.post == 0 ? 0 : (data.post / data.data.goal) * 100;
    },
    graph_mai(data) {
      return data.span.per.sheets;
    },
    graph_day(data) {
      return data.span.per.days;
    },
    timeTransfer(unixTime) {
      var date = new Date(unixTime);
      return `${date.getUTCFullYear()}/${
        date.getUTCMonth() + 1
      }/${date.getUTCDate()}`;
    },
    maiSend(uid, name, to_uid, to_name, cid) {
      // maiを送れるのは1秒に一回まで
      let count = 1;
      firebaseUtil
        .setChallengeMai(uid, name, to_uid, to_name, cid, count)
        .then(() => {
          this.sendMai = true;
          setTimeout(() => {
            this.sendMai = false;
          }, 1000);
        });
    },
    rebase() {},
  },
};
</script>

<style lang="scss">
.challenge {
  &_header {
    &_wrapper {
      display: flex;
      flex-direction: column-reverse;
    }
    @include Section_padding();
    margin-top: 0;
    padding-top: 0;
    padding-bottom: 0;
    height: 56px;
    .inner {
      display: flex;
      align-items: center;
      width: 100%;
      height: 100%;
      padding: 0 20px;
      position: relative;
      background-color: #fff;
      border-radius: 4px;
    }
    .header {
      &_title {
        margin-left: 20px;
      }
      &_btn_chip {
        @include icon(40px);
        position: absolute;
        right: 0;
        top: calc(50% - 20px);
        bottom: 24px;
      }
      &_btn_edit {
        @include fz(16);
        position: absolute;
        right: 0;
        padding: 4px 20px;
        border-radius: 4px;
        border: 1px solid #000;
        background-color: #fff;
      }
    }
    @include sp {
      &_wrapper {
        flex-direction: column;
      }
    }
  }
}

.challenge {
  &_detail {
    @include Section_padding();
    margin-top: 0;
    .detail {
      &_header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        .header {
          &_status_user {
            display: grid;
            align-items: center;
            grid-template-areas:
              "a b"
              "a c";
            grid-column-gap: 10px;
            .user {
              &_icon {
                grid-area: a;
                @include icon(40px);
                border: 2px solid $bg_accent;
                background-color: #fff;
              }
              &_name {
                grid-area: b;
                @include fz(16);
                align-self: start;
                max-width: 120px;
                min-width: 84px;
                overflow: hidden;
              }
              &_status {
                grid-area: c;
                @include fz(12);
                align-self: start;
                max-width: 120px;
                min-width: 84px;
                overflow: hidden;
              }
            }
          }
          &_counter {
            margin: 20px 0 40px;
            margin-left: auto;
            text-align: center;
            .title {
              @include fz(14);
            }
            display: flex;
            align-items: center;
            justify-content: flex-end;
          }
          &_btn_cheer {
            @include cheer_btn();
            position: relative;
            min-width: 100px;
            margin: 0 20px;
          }
        }
      }
      &_graph {
        .graph {
          &_header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 10px;
          }
          width: 100%;
          height: 30px;
          background-color: $bg_accent;
          border-radius: 15px;
          position: relative;
          padding: 2px;
          &_color {
            border-radius: 15px;
            height: 100%;
            width: 4%;
            background-color: $main_orange;
          }
          &_percentage {
            position: absolute;
            right: 20px;
            top: 0;
            height: 30px;
            @include flex_c();
          }
          &_footer {
            text-align: left;
            padding: 0 10px;
            p {
              margin-top: 6px;
            }
          }
        }
      }
    }
    @include sp {
      padding-top: 40px;
      padding-bottom: 40px;
    }
  }
}
</style>